/**
 * Sending a signed-out customer to log in WITHOUT losing where they were going.
 *
 * `history.push('/login')` on its own drops the destination: after logging in the
 * customer lands on the home page, not on the vehicle they were viewing. The login
 * page returns to `location.state.from`, so every "sign in to continue" must carry
 * one — and it must be an internal path (util/safeReturnPath).
 */

import { sanitizeReturnPath } from './safeReturnPath';

/** The page the customer is on right now, as an internal path. */
export const hereOf = history => {
  const { pathname = '/', search = '', hash = '' } = history.location || {};
  return `${pathname}${search}${hash}`;
};

/**
 * @param {Object} history react-router history
 * @param {string} from internal path to return to after authentication
 */
export const goToLogin = (history, from) => {
  const safe = sanitizeReturnPath(from, null);
  if (safe) history.push('/login', { from: safe });
  else history.push('/login');
};
